import {
  MAX_TAG_LENGTH,
  replaceDoubleUnderscoresToSingleUnderscore
} from "../../utils/tag.utils";
import { getNanoId } from "../../utils/general.utils";
import { dedupePrefix, dedupeSeparator } from "./dedupe.constants";
import { NANOID_LENGTH } from "../../constants/general.constants";
/**
 * This will suffix tag if there is no existing suffix
 * but otherwise it'll replace the older suffix with new one
 * @param tag
 * @param suffix
 */

const TRIMMED_TAG_LENGTH_BEFORE_ADDING_NEW_SUFFIX =
  MAX_TAG_LENGTH - (NANOID_LENGTH + dedupeSeparator.length);

export const suffixTag = (tag: string) => {
  const suffix = getNanoId();
  const separatedTag = tag.split(dedupeSeparator);

  const trimmedTag = separatedTag[0].substring(
    0,
    TRIMMED_TAG_LENGTH_BEFORE_ADDING_NEW_SUFFIX
  );
  separatedTag[0] = trimmedTag;

  if (
    separatedTag.length > 1 &&
    separatedTag[separatedTag.length - 1].length === NANOID_LENGTH
  ) {
    // Suffix is already present
    separatedTag.splice(separatedTag.length - 1, 1, suffix);

    return replaceDoubleUnderscoresToSingleUnderscore(
      separatedTag.join(dedupeSeparator)
    );
  } else {
    return replaceDoubleUnderscoresToSingleUnderscore(
      `${trimmedTag}${dedupeSeparator}${suffix}`
    );
  }
};

export const prefixCopy = (name: string) => {
  if (name.indexOf(dedupePrefix) === 0) {
    return name;
  } else {
    return `${dedupePrefix}${name}`;
  }
};
